import { pricingServices } from 'src/services/reservation/pricing/pricing.service'
import { customAwait } from 'src/components/pages/sales/reservation/helper/customAwait'
import { eventBus } from 'src/helper/EventBus'
export const handleUpdatePricing = async (
  record: any,
  cardId: String,
  setLoadingPricingModal: React.Dispatch<React.SetStateAction<boolean>>,
  setOpenPricingModal: React.Dispatch<React.SetStateAction<boolean>>,
  notify: any,
  refresh: any,
  setCardLoading: any,
  reservation: any | null
) => {
  try {
    setLoadingPricingModal(true)
    if (record && record?.pricing_relation) {
      const {
        pricing_relation,
        product: { hash_product },
      } = record
      const business_unit_token = reservation?.business_unit_relation?.token
      const work_unit_token = reservation?.work_unit_relation?.token
      const product_hash = hash_product

      if (pricing_relation.length > 0) {
        let pricing_relation_aux = addBusinessUnitTokenInRequestRule(
          pricing_relation[0],
          business_unit_token,
          work_unit_token,
          product_hash
        )
        if (pricing_relation_aux.currency_to_show && pricing_relation_aux.currency_origin) {
          pricing_relation_aux.currency_to_show[pricing_relation_aux.currency_origin] =
            pricing_relation_aux.currency_to_show[pricing_relation_aux.currency_origin] || 1
        }
        const response = await pricingServices.calculateLiquidationRuleFromPricing(
          pricing_relation[0].id,
          pricing_relation_aux
        )
        if (response) {
          notify('ra.notification.updated_success_pricing', {
            type: 'success',
          })
          eventBus.emit('updateBillingStatus', record?.hash_)
          return
        }
      }
    }
    notify('ra.notification.updated_error_pricing', {
      type: 'error',
    })
  } catch (error) {
    notify('ra.notification.updated_error_pricing', {
      type: 'error',
    })
  } finally {
    setLoadingPricingModal(false)
    setOpenPricingModal(false)
    setCardLoading(cardId, true)
    customAwait([refresh])
  }
}

type RuleParameters = {
  rules_parameters: Record<string, any>
}

type LiquidationType = {
  liquidation_supplier?: {
    requestRule: RuleParameters
  }
  liquidation_wholesaler?: {
    requestRule: RuleParameters
  }
  liquidation_retail?: {
    requestRule: RuleParameters
  }
}

const addBusinessUnitTokenInRequestRule = (
  liquidation: any,
  business_unit_token: string | null,
  work_unit_token: string | null,
  product_hash: string | null
) => {
  const keysToCheck: (keyof LiquidationType)[] = [
    'liquidation_supplier',
    'liquidation_wholesaler',
    'liquidation_retail',
  ]

  for (const key of keysToCheck) {
    const requestRule = liquidation[key]?.requestRule
    if (requestRule?.rules_parameters) {
      requestRule.rules_parameters.business_unit_token = business_unit_token
      requestRule.hash_product = product_hash
      requestRule.token_workunit = work_unit_token
    }
  }
  return liquidation
}
